'use client';
import { jsx, jsxs } from 'react/jsx-runtime';
import { useDeprecatedProps } from '../../hooks/use-deprecated-props.js';
import { Spinner } from '../spinner/spinner.component.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _define_property(t, e, r) {
    return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: true,
        configurable: true,
        writable: true
    }) : t[e] = r, t;
}
function _object_spread(t) {
    for(var e = 1; e < arguments.length; e++){
        var r = null != arguments[e] ? arguments[e] : {}, n = Object.keys(r);
        "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(r).filter(function(t) {
            return Object.getOwnPropertyDescriptor(r, t).enumerable;
        }))), n.forEach(function(e) {
            _define_property(t, e, r[e]);
        });
    }
    return t;
}
function ownKeys(t, e) {
    var r = Object.keys(t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        r.push.apply(r, n);
    }
    return r;
}
function _object_spread_props(t, e) {
    return e = null != e ? e : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(e)) : ownKeys(Object(e)).forEach(function(r) {
        Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(e, r));
    }), t;
}
function _object_without_properties(t, e) {
    if (null == t) return {};
    var r, n, o = _object_without_properties_loose(t, e);
    if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(t);
        for(n = 0; n < a.length; n++)r = a[n], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(t, r) && (o[r] = t[r]);
    }
    return o;
}
function _object_without_properties_loose(t, e) {
    if (null == t) return {};
    var r, n, o = {}, a = Object.keys(t);
    for(n = 0; n < a.length; n++)r = a[n], e.indexOf(r) >= 0 || (o[r] = t[r]);
    return o;
}
const Button = renderWithRef('Button', null, (n, s)=>{
    var i;
    useDeprecatedProps('Button', n, [
        {
            propName: 'size',
            instructions: 'Sizing is now handled automatically by standardMode/compactMode'
        }
    ]);
    let { as: d, component: c, skin: p = 'secondary', size: u = 'standard', width: l = 'standard', specialVariant: b = 'standard', iconPosition: f, buttonShape: y = 'standard', children: w, type: _, loading: j } = n, O = _object_without_properties(n, [
        "as",
        "component",
        "skin",
        "size",
        "width",
        "specialVariant",
        "iconPosition",
        "buttonShape",
        "children",
        "type",
        "loading"
    ]), m = null !== (i = null != d ? d : c) && void 0 !== i ? i : 'button', h = 'button' === m || 'input' === m ? null != _ ? _ : 'button' : _, g = ![
        'unstyled',
        'clear-selection',
        'link'
    ].includes(null != p ? p : 'secondary'), P = new Set([]);
    if (g && (P.add('swan-button'), P.add(`swan-button-skin-${p}`)), g || P.add(`swan-button-skin-${p}`), 'round' === y && P.add('swan-button-round'), 'left' === f && P.add('swan-button-with-icon-left'), ('design-path' !== b || f) && 'right' !== f || P.add('swan-button-with-icon-right'), 'standard' !== u && g && P.add(`swan-button-${u}`), 'standard' === u || g || P.add(`swan-button-${u}`), 'standard' !== l && P.add(`swan-button-${l}`), 'design-path' === b && P.add("swan-button-design-path"), j && P.add('swan-button-loading'), 'input' === m) return jsx(RenderComp, {
        root: "input",
        forwardedRef: s,
        classNames: P,
        props: _object_spread_props(_object_spread({}, O), {
            type: h
        }),
        children: w
    });
    let v = _object_spread({
        'aria-disabled': j || void 0,
        type: _,
        as: m
    }, O);
    return jsxs(RenderComp, {
        root: "button",
        forwardedRef: s,
        classNames: P,
        props: 'button' === m ? _object_spread_props(_object_spread({}, v), {
            type: h
        }) : v,
        children: [
            w,
            j && jsx(Spinner, {
                accessibleText: "",
                "aria-hidden": true
            })
        ]
    });
});

export { Button };
